import React from "react";
import { Link } from "react-router-dom";
import CoverBlock from "../../../components/CoverBlock";
import { eventPublicPath } from "../../../lib/eventLinks";
import { ReadableCard } from "../../../components/Sticker";
import CrewNudgeLine from "./CrewNudgeLine.jsx";

export default function CrewSignalFeedCard({
  item,
  showTooltip = false,
}) {
  const ev = item.event;
  const cardPath = ev ? eventPublicPath(ev, { occurrenceDate: item.occurrence_date }) : null;

  if (!ev) return null;

  return (
    <ReadableCard
      className="p-0 overflow-hidden relative group"
      data-testid={`crew-signal-card-${item.id}`}
    >
      <Link
        to={cardPath}
        className="absolute inset-0 z-10 rounded-[inherit]"
        aria-label={`RSVP to ${ev.name}`}
        data-testid={`crew-signal-view-${item.id}`}
      />
      <CoverBlock coverColor={ev.cover_color} className="px-4 pt-4 pb-2 relative">
        <h3 className="font-display font-semibold text-[20px] leading-tight text-balance break-words">
          {ev.name}
        </h3>
        <CrewNudgeLine
          show={item.crew_signal?.show}
          showTooltip={showTooltip}
          tooltipContext="main-feed"
        />
      </CoverBlock>
    </ReadableCard>
  );
}
